module.exports = {
    siteTitle: 'Techno-Zone ITcare',
    welcomeText: 'WELCOME TO Techno-Zone ITcare',
    heading: 'We are a creative group of people who design awesome solutions for your business.',
    subHeading: 'Consumer First Always!',
    manifestName: 'Techno-Zone ITcare',
    manifestShortName: 'Landing Techno-Zone ITcare',
    manifestStartUrl: '/',
    manifestBackgroundColor: '#663399',
    manifestThemeColor: '#663399',
    manifestDisplay: 'standalone',
    manifestIcon: 'src/assets/img/website-icon.png',
    pathPrefix: `technozoneitcare`,
    GOOGLE_RECAPTCHA_KEY: '6LcaTuAUAAAAAEZRuZBlfWmf4L7tl8CP9OGrK1aZ',
    //README https://www.google.com/recaptcha/admin/site/350244378/setup


    // social
    socialLinks: [
        {
            icon: 'fa-linkedin-in',
            name: 'Linkedin',
            url: 'https://www.linkedin.com/company/technozoneitcare',
        },
        {
            icon: 'fa-twitter',
            name: 'Twitter',
            url: 'https://twitter.com/technozonItcare',
        },
        {
            icon: 'fa-facebook-f',
            name: 'Facebook',
            url: 'https://www.facebook.com/technozoneitcareofficial',
        },
        {
            icon: 'fa-instagram',
            name: 'Instagram',
            url: 'https://www.instagram.com/technozoneitcare',
        }
    ],
    email: 'technozoneitcare@gmail.com  support@technozoneitcare.com',
    phone: '+91-95942-80890',
    address: 'R-5, Satyam Co. Op. Housing Society, Ram Mandir Road, Goregaon west, Mumbai - 4000104',
};
